import { useDispatch, useSelector } from 'react-redux';
import { filterTheData } from '../../actions';
import { FetchCaseBrandModel } from '../../models/case_study';
interface propsTypes {
  filterItem:{
    title: string,
    subtitle: string[],
  }
}

const FilterItem: React.FC<propsTypes> = (props) => {
  const {title, subtitle} = props.filterItem;
  const csBrand = useSelector((state: FetchCaseBrandModel) =>( {"cs_full_list": state.case_study}));
  const dispatch = useDispatch();

  const filter = ( name:string, e:any) =>{
    dispatch(filterTheData(title, name, csBrand));

    e.target.getAttribute("style") == null ? e.target.style.color = "red":  e.target.removeAttribute("style")
  }

  return (
    <div className="filterItem">
      <h3 className="title">{title}</h3>
      {
        subtitle.map((name:string, i: number) =>{
          return <p className={`subtitle subtitle-${i}`} 
          key={i} 
          style={{animationDelay: `${i/10}s;` }} 
          onClick={(e)=>filter(name,e)}>{name}</p>
        })
      }
    </div>
  )
}

export default FilterItem
